import React from 'react';

import './item.scss';

export default class LearningPathItem extends React.Component {
    static defaultProps = {
        sessionsText: 'sessions',
        sessionText: 'session',
        labsText: 'labs',
        labText: 'lab'
    }

    render() {
        const {index, data, selected, onClick, sessionsText, sessionText, labsText, labText} = this.props;
        const className = 'item ' + (selected ? ' selected' : '');
        let pathIconSrc;
        if (this.props.data.MetaDetail !== null && this.props.data.MetaDetail.hasOwnProperty("Icon")) {
            pathIconSrc = this.props.data.MetaDetail.Icon;
        } else {
            pathIconSrc = "https://developer.cisco.com/learning/assets/icons/icon-collaboration.svg";
        }
        /*const iconStyle = {
            backgroundImage: `url(${pathIconSrc})`
        }*/

        const sessions = this.renderCount(data.sessionCount, sessionsText, sessionText);
        const labs = this.renderCount(data.labCount, labsText, labText);

        if (!data.hasOwnProperty('progress')) {
            data.progress = 0;
        }

        const prgValClass = {
            width: (data.progress || 0) + '%'
        }


        let progressValueClassname = '';
        if (data.progress <= 50) {
            progressValueClassname = `p${data.progress}`;
        } else {
            progressValueClassname = `over50 p${data.progress}`;
        }

        return (
            <div className={className}
                 data-index={index}
                 onClick={onClick}
                 id={data.id.toLowerCase()}>
                <div className='flex'>
                    <div className={window.PlatformSDK.isLoggedIn() ? "prg show-progress" : "prg"}>
                        <div className='icon-col'>
                            <div className={'icon-container ' + data.id}>
                            </div>
                        </div>
                        <div className={"progress-circle " + progressValueClassname}>
                            <span>{data.progress}%</span>
                            <div className="left-half-clipper">
                                <div className="first50-bar"></div>
                                <div className="value-bar"></div>
                            </div>
                        </div>

                        {/*<div className='prg-bar'>
                            <div className='prg-val' >
                                <div className='icon-col'>
                                    <div className='icon-container' style={iconStyle}>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                    </div>
                    <div className='text-col'>
                        <div className='path-info'>
                            <span className={"duration"}>
                                {Math.ceil(data.Duration/60) + " Hours "}
                            </span>
                            <span className={"labs"}>
                                {labs}
                            </span>
                        </div>
                        <div className='path-title'>
                            {data.Title}
                        </div>
                        <div className='path-description'>
                            {data.Description}
                        </div>
                    </div>

                </div>
            </div>
        );
    }

    renderCount(data, plur, single) {
        const text = data + ' ' + (data > 1 ? (plur || single || '') : (single || plur || ''));
        return (
            <span className='part'>
                {text}
            </span>
        );
    }
}
